import { Button, Link } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";

import Modal from "../Modal";
import VideoPlayer from "../VideoPlayer";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";

import { ASSET_API_URL, Constants } from "../../constants/constants";

interface IPreviewFileDialog {
    open: boolean;
    fileId: string;
    fileName?: string;
    type: "image" | "video" | "document";
    onClose: () => void;
}

const PreviewFileDialog: React.FC<IPreviewFileDialog> = (props: IPreviewFileDialog) => {
    const strings = useStrings();
    if (Helpers.isNullOrEmpty(props.fileId)) {
        return null;
    }

    let title: string;
    switch (props.type) {
        case "image":
            title = strings.Common.IMAGE;
            break;

        case "video":
            title = strings.Common.VIDEO;
            break;

        default:
            title = strings.Common.DOCUMENT;
            break;
    }
    title += !Helpers.isNullOrEmpty(props.fileName)
        ? `: ${props.fileName}`
        : "";

    return (
        <Modal
            title={title}
            visible={props.open}
            onClose={props.onClose}
        >
            {props.type === "image" && (
                <img
                    alt="preview"
                    loading="lazy"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    src={Helpers.getFileAccessUrl(props.fileId)}
                />
            )}

            {props.type === "video" && (
                <VideoPlayer fileId={props.fileId} />
            )}

            {props.type === "document" && (
                <Button
                    download
                    component={Link}
                    target={"_blank"}
                    style={{ fontSize: 16 }}
                    startIcon={<DownloadIcon />}
                    href={(Helpers.isNullOrEmpty(props.fileId) || props.fileId === "0")
                        ? ""
                        : ASSET_API_URL + Constants.ApiPath.ASSET.GET_ASSET_DOWNLOAD_URL + `/${props.fileId}`
                    }
                >
                    {strings.Common.DOWNLOAD}
                </Button>
            )}
        </Modal >
    );
}

export default PreviewFileDialog;